import * as ActionsTypes from "../../../../common/constants/stateConstants";

/*---------------------------------------------GET-CONSULTATION-PACKAGES-LIST-------------------------------------------------*/
export const getConsultationPackagesListAction = (payload) => {
  return {
    type: ActionsTypes.GET_CONSULTATION_PACKAGES_LIST,
    payload,
  };
};

export const getConsultationPackagesListSuccessAction = (payload) => {
  return {
    type: ActionsTypes.GET_CONSULTATION_PACKAGES_LIST_SUCCESS,
    payload,
  };
};

export const getConsultationPackagesListFailAction = (payload) => {
  return {
    type: ActionsTypes.GET_CONSULTATION_PACKAGES_LIST_FAIL,
    payload,
  };
};

/*---------------------------------------------GET-HISTORIQUE-PACKAGE-------------------------------------------------*/
export const getHistoriquePackageAction = (payload) => {
  return {
    type: ActionsTypes.GET_HISTORIQUE_PACKAGE,
    payload,
  };
};

export const getHistoriquePackageSuccessAction = (payload) => {
  return {
    type: ActionsTypes.GET_HISTORIQUE_PACKAGE_SUCCESS,
    payload,
  };
};

export const getHistoriquePackageFailAction = (payload) => {
  return {
    type: ActionsTypes.GET_HISTORIQUE_PACKAGE_FAIL,
    payload,
  };
};

export const getHistoriquePackageReinitializationAction = (payload) => {
  return {
    type: ActionsTypes.GET_HISTORIQUE_PACKAGE_REINITIALIZATION,
    payload,
  };
};

/*---------------------------------------------DELETE-PACKAGE-------------------------------------------------*/
export const deletePackageAction = (payload) => {
  return {
    type: ActionsTypes.DELETE_PACKAGE,
    payload,
  };
};

export const deletePackageSuccessAction = (payload) => {
  return {
    type: ActionsTypes.DELETE_PACKAGE_SUCCESS,
    payload,
  };
};

export const deletePackageFailAction = (payload) => {
  return {
    type: ActionsTypes.DELETE_PACKAGE_FAIL,
    payload,
  };
};

export const deletePackageReinitializationAction = (payload) => {
  return {
    type: ActionsTypes.DELETE_PACKAGE_REINITIALIZATION,
    payload,
  };
};

/*------------------------------------------Excel---------------------*/
export const excelExport = (payload) => {
  return {
    type: ActionsTypes.GENERAL_EXCEL_PACKAGE_EXPORT,
    payload,
  };
};
export const printSuccess = (payload) => {
  return {
    type: ActionsTypes.GENERAL_PRINT_PACKAGE_SUCCESS,
    payload,
  };
};
export const printFail = (payload) => {
  return {
    type: ActionsTypes.GENERAL_PRINT_PACKAGE_FAIL,
    payload,
  };
};
export const printReinitialization = (payload) => {
  return {
    type: ActionsTypes.GENERAL_PRINT_PACKAGE_REINITIALIZATION,
    payload,
  };
};